import(/* webpackMode: "eager" */ "/usr/src/app/frontend/src/app/(editor)/@appBar/page.tsx");
